import React from 'react'
import { PaperCard, TextBlock } from '../../../components/1elements'
import { Field, ErrorMessage } from 'formik'

import Switch from '@mui/material/Switch'
import { renderBucket } from './bucketRenderer'
import { Loader } from '../../../components/1elements'
import { makeStyles } from '@material-ui/core/styles'
import CollapsableContainerForLeftCard from '../../2compounds/CollapsableContainerForLeftCard'
import { Text } from '../../../components/1elements'
import DeleteButtonGroupDetails from '../../../components/1elements/Buttons/TextButtons/DeleteButtonGroupDetails'

const LeftCard = ({
  formikProps,
  editMode,
  typeIdToDisplayName,
  deleteEntityCallback,
  activationChangeCallback,
  listOfTypes,
  arrayOfBucketConfig,
  entityDisplayName,
  children,
  hideSuspend = false,
  shortFormat = false
}) => {
  const classes = useStyles({ shortFormat })
  if (!arrayOfBucketConfig) return <Loader />

  const values = formikProps.values
  //console.log(values)
  const active = values.suspended_at ? false : true
  const hasEmail =
    values.hasOwnProperty('meta') && values.meta.hasOwnProperty('email')
  const hasDescription = values.hasOwnProperty('description')
  const hasType =
    values.hasOwnProperty('type') && listOfTypes && listOfTypes.length > 0
  const createMode = !values.hasOwnProperty('id')
  const sectionName = values.type
    ? typeIdToDisplayName(values.type)
    : entityDisplayName

  return (
    <PaperCard className={classes.column}>
      <CollapsableContainerForLeftCard
        text={`${sectionName} Info`}
        contentClassName={classes.collapsableContentClass}
        shortFormat={shortFormat}
      >
        {children ? (
          children
        ) : (
          <div className={classes.infoRowWrapper}>
            <div className={classes.infoRow}>
              <Text
                className={classes.infoTitle}
                type='h3'
              >{`${sectionName} Name: `}</Text>
              {editMode ? (
                <Field className={classes.textBox} name='name' required />
              ) : (
                <Text className={classes.infoSubTitle} type='p'>
                  {values.name}
                </Text>
              )}
            </div>
            {hasDescription && (
              <div className={classes.infoRow}>
                <Text
                  className={classes.infoTitle}
                  type='h3'
                >{`Description: `}</Text>
                {editMode ? (
                  <Field
                    className={classes.multiLineTextBox}
                    name='description'
                    as='textarea'
                    value={values.description ? values.description : ''}
                    required
                  />
                ) : (
                  <Text className={classes.infoSubTitle} type='p'>
                    {values.description}
                  </Text>
                )}
              </div>
            )}
            {hasType && (
              <div className={classes.infoRow}>
                <Text className={classes.infoTitle} type='h3'>{`Type: `}</Text>
                <Text className={classes.infoSubTitle} type='p'>
                  {sectionName}
                </Text>
                {editMode ? (
                  <Field
                    className={classes.infoSubTitle}
                    name='type'
                    as='select'
                    disabled
                    style={{ display: 'none' }}
                  >
                    {listOfTypes.map((oneType, index) => (
                      <option key={index} value={oneType}>
                        {typeIdToDisplayName(oneType)}
                      </option>
                    ))}
                  </Field>
                ) : (
                  <Text
                    className={classes.infoSubTitle}
                    type='p'
                    style={{ display: 'none' }}
                  >
                    {sectionName}
                  </Text>
                )}
              </div>
            )}
            {hasEmail && (
              <div className={classes.infoRow}>
                <Text className={classes.infoTitle} type='h3'>{`Email: `}</Text>
                {editMode ? (
                  <Field
                    className={classes.textBox}
                    name='meta.email'
                    required
                    type='email'
                  />
                ) : (
                  <Text className={classes.infoSubTitle} type='p'>
                    {values.meta.email}
                  </Text>
                )}
              </div>
            )}
          </div>
        )}
      </CollapsableContainerForLeftCard>

      {arrayOfBucketConfig.map((oneBucket, index) => (
        <TextBlock key={index}>
          {renderBucket(
            oneBucket,
            formikProps,
            editMode,
            classes.dropDownCollapsableContent
          )}
          <div style={{ color: 'red' }}>
            <ErrorMessage name='owner_ids' key={index} />
          </div>
        </TextBlock>
      ))}

      {!createMode && (
        <CollapsableContainerForLeftCard
          text='Assigned Status'
          contentClassName={classes.collapsableContent}
        >
          { !hideSuspend &&
            <div className={classes.activSuspended}>
              <Text type='h3' className={!active && classes.activeText}>
                Suspended
              </Text>
              <Switch
                className={classes.switchButton}
                disabled={!editMode}
                checked={active}
                onChange={(_, checked) => {
                  activationChangeCallback(values.id, checked)
                }}
              />
              <Text type='h3' className={active && classes.activeText}>
                Active
              </Text>
            </div>
          }
          <DeleteButtonGroupDetails
            text={`Delete ${
              sectionName.includes('Group') ? 'Group' : sectionName
            }`}
            className={classes.deleteButton}
            onClick={() => deleteEntityCallback(values.id)}
            disabled={!editMode}
          />
          <Text type='h6' className={classes.subScript}>
            <sup>*</sup>
            {`After deleting ${sectionName} it will be deleted permanently`}
          </Text>
        </CollapsableContainerForLeftCard>
      )}
    </PaperCard>
  )
}

export default LeftCard

const useStyles = makeStyles((theme, props) => ({
  column: {
    height: '700px',
    padding: '20px 10px',
    border: `2px solid ${theme.palette.quaternary.accent}`,
    '&.MuiPaper-elevation3': {
      boxShadow: 'none'
    },
    '&>div>div': {
      marginTop: '25px'
    },
    '&>div>:first-child': {
      marginTop: '0px'
    },
    '&::-webkit-scrollbar': {
      width: 5
    }
  },
  infoRowWrapper: {
    width: '100%',
    '&>:first-child': {
      marginTop: '0'
    }
  },
  infoRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginTop: '20px'
  },
  infoTitle: {
    color: theme.palette.tertiary.main
  },
  infoSubTitle: {
    color: theme.palette.primary.main,
    marginTop: '5px'
  },
  collapsableContentClass: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: props => (props.shortFormat ? '150px' : 'auto'),
    '& .MuiCollapse-wrapper': {
      display: 'flex',
      flexDirection: 'column',
      '& .MuiCollapse-wrapperInner': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }
    },
    '&::-webkit-scrollbar': {
      width: 5
    }
  },
  dropDownCollapsableContent: {
    '&+.MuiList-root': {
      maxHeight: '150px',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: 5
      }
    }
  },
  switchButtonWrapper: {
    color: theme.palette.primary.accent
  },
  activeText: {
    color: theme.palette.primary.accent
  },

  switchButton: {
    '& .MuiSwitch-switchBase.Mui-checked': {
      '& .MuiSwitch-thumb': {
        color: theme.palette.primary.accent
      }
    },
    '& .MuiSwitch-switchBase': {
      '& .MuiSwitch-thumb': {
        color: theme.palette.secondary.accent
      }
    },
    '& .css-5ryogn-MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track':
      {
        backgroundColor: 'white',
        border: `1px solid ${theme.palette.primary.accent}`
      },
    '& .MuiSwitch-track': {
      backgroundColor: 'white',
      border: `1px solid ${theme.palette.primary.accent}`
    }
  },
  deleteButton: {
    marginTop: '5px'
  },
  subScript: {
    marginTop: '10px'
  },
  textBox: {
    ...theme.typography.p,
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.tertiary.accent}`,
    width: '70%',
    height: '23px',
    borderRadius: '5px',
    marginTop: '5px'
  },
  multiLineTextBox: {
    ...theme.typography.p,
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.tertiary.accent}`,
    width: '70%',
    height: '50px',
    borderRadius: '5px',
    marginTop: '5px'
  }
}))
